import BookingSidebar from '@/components/booking/Sidebar'
import { API } from '@/modules/api'

function conditionMatches (e) {
  const activeElement = e.target.activeElement

  const reservationButton = activeElement && activeElement.classList.contains('reservation-button')
  const submitButton = activeElement.type == 'submit'
  
  log.debug('__bookingSidebar.preventPageRefresh__')
  log.debug('reservationButton clicked:', reservationButton, ' submitButton clicked:', submitButton)
  log.debug('Any possible clicked:', reservationButton || submitButton)
  
  if (reservationButton || submitButton) return false
  else return true
}

function preventPageRefresh () {
  window.addEventListener('beforeunload', e => {
    if (conditionMatches(e)) {
      e.preventDefault() 
      e.returnValue = ''
    }
  }) 
}

export function init () {
  // There are two elements with the same class and only one that is main data container
  const root = document.querySelectorAll('.booking-sidebar').filter(elem => elem.id)[0]
  
  if (root) {
    const { offer } = new API().getBookingSidebarStaticData(root.id)
    preventPageRefresh()
    new BookingSidebar({ el: root, propsData: { data: offer } })
  }
}


// WEBPACK FOOTER //
// ./src/modules/bookingSidebar.js